define('models/NewsCollection',['underscore','ObjectCollection','LocalStorage','models/NewsModel'],function (_,ObjectCollection,LocalStorage,NewsModel) {
    //
    // Collection News
    //
    var NewsCollectionPrototype = {
        
        name:'NewsCollection',
        route:'apiNewsCollection',
        model:NewsModel,
        initialize:function(){
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this,arguments);
            //
        },
        filterByFlag:function(flag){
            var collection = this, isAllNews = flag.isAllNews(),filtred;

            filtred = [];
            _(flag.get('news')).each(function(id_news){
                var news = collection.get(id_news);
                if(news && news.isNews()) filtred.push(news);
            });
            if(isAllNews){
                // on ajoute les news en fin si elles n'ont pas été flagé "toutes les news"
                collection.each(function(news){
                    if(news.isNews() && !flag.contains(news.id)){
                        filtred.push(news);
                    }
                })
            }

            return new NewsCollection(filtred);
        }
    };

    var NewsCollection = ObjectCollection.extend(LocalStorage).extend(NewsCollectionPrototype);

    return NewsCollection;
});
